export const conditionalAttributesColumnDefinitions=[
	{
		id: 'attributeName',
		header: 'Attribute Name',
		cell: item => item.attributeName,
		sortingField: 'alt',
		minWidth: 105,
	},
	{
		id: 'operator',
		header: 'Operator',
		cell: item => item.operator,
		minWidth: 105,
	},
	{
		id: 'attributeValue',
		header: 'Attribute Value',
		cell: item => item.attributeValue,
		minWidth: 105,
	},
];